var map = {
	"./af-ZA.json": [
		"../../packages/uniswap/src/i18n/locales/translations/af-ZA.json",
		"packages_uniswap_src_i18n_locales_translations_af-ZA_json"
	],
	"./ar-SA.json": [
		"../../packages/uniswap/src/i18n/locales/translations/ar-SA.json",
		"packages_uniswap_src_i18n_locales_translations_ar-SA_json"
	],
	"./ca-ES.json": [
		"../../packages/uniswap/src/i18n/locales/translations/ca-ES.json",
		"packages_uniswap_src_i18n_locales_translations_ca-ES_json"
	],
	"./cs-CZ.json": [
		"../../packages/uniswap/src/i18n/locales/translations/cs-CZ.json",
		"packages_uniswap_src_i18n_locales_translations_cs-CZ_json"
	],
	"./da-DK.json": [
		"../../packages/uniswap/src/i18n/locales/translations/da-DK.json",
		"packages_uniswap_src_i18n_locales_translations_da-DK_json"
	],
	"./de-DE.json": [
		"../../packages/uniswap/src/i18n/locales/translations/de-DE.json",
		"packages_uniswap_src_i18n_locales_translations_de-DE_json"
	],
	"./el-GR.json": [
		"../../packages/uniswap/src/i18n/locales/translations/el-GR.json",
		"packages_uniswap_src_i18n_locales_translations_el-GR_json"
	],
	"./es-ES.json": [
		"../../packages/uniswap/src/i18n/locales/translations/es-ES.json",
		"packages_uniswap_src_i18n_locales_translations_es-ES_json"
	],
	"./fi-FI.json": [
		"../../packages/uniswap/src/i18n/locales/translations/fi-FI.json",
		"packages_uniswap_src_i18n_locales_translations_fi-FI_json"
	],
	"./fr-FR.json": [
		"../../packages/uniswap/src/i18n/locales/translations/fr-FR.json",
		"packages_uniswap_src_i18n_locales_translations_fr-FR_json"
	],
	"./he-IL.json": [
		"../../packages/uniswap/src/i18n/locales/translations/he-IL.json",
		"packages_uniswap_src_i18n_locales_translations_he-IL_json"
	],
	"./hi-IN.json": [
		"../../packages/uniswap/src/i18n/locales/translations/hi-IN.json",
		"packages_uniswap_src_i18n_locales_translations_hi-IN_json"
	],
	"./hu-HU.json": [
		"../../packages/uniswap/src/i18n/locales/translations/hu-HU.json",
		"packages_uniswap_src_i18n_locales_translations_hu-HU_json"
	],
	"./id-ID.json": [
		"../../packages/uniswap/src/i18n/locales/translations/id-ID.json",
		"packages_uniswap_src_i18n_locales_translations_id-ID_json"
	],
	"./it-IT.json": [
		"../../packages/uniswap/src/i18n/locales/translations/it-IT.json",
		"packages_uniswap_src_i18n_locales_translations_it-IT_json"
	],
	"./ja-JP.json": [
		"../../packages/uniswap/src/i18n/locales/translations/ja-JP.json",
		"packages_uniswap_src_i18n_locales_translations_ja-JP_json"
	],
	"./ko-KR.json": [
		"../../packages/uniswap/src/i18n/locales/translations/ko-KR.json",
		"packages_uniswap_src_i18n_locales_translations_ko-KR_json"
	],
	"./ms-MY.json": [
		"../../packages/uniswap/src/i18n/locales/translations/ms-MY.json",
		"packages_uniswap_src_i18n_locales_translations_ms-MY_json"
	],
	"./nl-NL.json": [
		"../../packages/uniswap/src/i18n/locales/translations/nl-NL.json",
		"packages_uniswap_src_i18n_locales_translations_nl-NL_json"
	],
	"./no-NO.json": [
		"../../packages/uniswap/src/i18n/locales/translations/no-NO.json",
		"packages_uniswap_src_i18n_locales_translations_no-NO_json"
	],
	"./pl-PL.json": [
		"../../packages/uniswap/src/i18n/locales/translations/pl-PL.json",
		"packages_uniswap_src_i18n_locales_translations_pl-PL_json"
	],
	"./pt-BR.json": [
		"../../packages/uniswap/src/i18n/locales/translations/pt-BR.json",
		"packages_uniswap_src_i18n_locales_translations_pt-BR_json"
	],
	"./pt-PT.json": [
		"../../packages/uniswap/src/i18n/locales/translations/pt-PT.json",
		"packages_uniswap_src_i18n_locales_translations_pt-PT_json"
	],
	"./ro-RO.json": [
		"../../packages/uniswap/src/i18n/locales/translations/ro-RO.json",
		"packages_uniswap_src_i18n_locales_translations_ro-RO_json"
	],
	"./ru-RU.json": [
		"../../packages/uniswap/src/i18n/locales/translations/ru-RU.json",
		"packages_uniswap_src_i18n_locales_translations_ru-RU_json"
	],
	"./sl-SI.json": [
		"../../packages/uniswap/src/i18n/locales/translations/sl-SI.json",
		"packages_uniswap_src_i18n_locales_translations_sl-SI_json"
	],
	"./sr-SP.json": [
		"../../packages/uniswap/src/i18n/locales/translations/sr-SP.json",
		"packages_uniswap_src_i18n_locales_translations_sr-SP_json"
	],
	"./sv-SE.json": [
		"../../packages/uniswap/src/i18n/locales/translations/sv-SE.json",
		"packages_uniswap_src_i18n_locales_translations_sv-SE_json"
	],
	"./sw-TZ.json": [
		"../../packages/uniswap/src/i18n/locales/translations/sw-TZ.json",
		"packages_uniswap_src_i18n_locales_translations_sw-TZ_json"
	],
	"./th-TH.json": [
		"../../packages/uniswap/src/i18n/locales/translations/th-TH.json",
		"packages_uniswap_src_i18n_locales_translations_th-TH_json"
	],
	"./tr-TR.json": [
		"../../packages/uniswap/src/i18n/locales/translations/tr-TR.json",
		"packages_uniswap_src_i18n_locales_translations_tr-TR_json"
	],
	"./uk-UA.json": [
		"../../packages/uniswap/src/i18n/locales/translations/uk-UA.json",
		"packages_uniswap_src_i18n_locales_translations_uk-UA_json"
	],
	"./ur-PK.json": [
		"../../packages/uniswap/src/i18n/locales/translations/ur-PK.json",
		"packages_uniswap_src_i18n_locales_translations_ur-PK_json"
	],
	"./vi-VN.json": [
		"../../packages/uniswap/src/i18n/locales/translations/vi-VN.json",
		"packages_uniswap_src_i18n_locales_translations_vi-VN_json"
	],
	"./zh-CN.json": [
		"../../packages/uniswap/src/i18n/locales/translations/zh-CN.json",
		"packages_uniswap_src_i18n_locales_translations_zh-CN_json"
	],
	"./zh-TW.json": [
		"../../packages/uniswap/src/i18n/locales/translations/zh-TW.json",
		"packages_uniswap_src_i18n_locales_translations_zh-TW_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "../../packages/uniswap/src/i18n/locales/translations lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;